import { PaginationData } from "@/app/types/common/PaginationData";

export function hasPages(data: PaginationData): boolean {
  return !!data.totalPages && data.totalPages > 1;
}
